<script setup>
import { computed, onMounted, ref } from 'vue';
import { useAuthStore } from "@/app/stores/authStore";

// Components
import EmployeesWithHolidaysNew from '@/components/shared/Home/EmployeesWithHolidaysNew.vue';

// Services
import HolidayService from "@/api/services/holiday.service";

const authStore = useAuthStore();

const showDialogHoliday = ref(false);
const holidaysResponse = ref({})

// Computed

const showHolidayButton = computed(() => {

    return holidaysResponse.value.holidaysOn7Days?.length > 0 || holidaysResponse.value.employeeHolidays?.daysLeft <= 10 || holidaysResponse.value.holidaysToday?.length > 0;
})
const user = computed(() => authStore.getUserLogged);


const holidays = computed(() => {
    if (holidaysResponse.value && (Array.isArray(holidaysResponse.value.holidaysOn7Days) && holidaysResponse.value.holidaysOn7Days.length > 0) || (Array.isArray(holidaysResponse.value.holidaysToday) && holidaysResponse.value.holidaysToday.length > 0)) {
        const list7 = holidaysResponse.value.holidaysOn7Days;
        const today = Array.isArray(holidaysResponse.value.holidaysToday)
            ? holidaysResponse.value.holidaysToday
            : [];
        return [...today, ...list7];
    } else {
        return [];
    }
});

onMounted(() => {
    getHolidays();
})

const getHolidays = () => {
    HolidayService.getNextHoliday(user.value.id).then((res) => {
        if (res && res.data && res.data.holidays) {
            holidaysResponse.value = res.data.holidays;
        }
    })
}

const openDialogHolidays = () => {
    showDialogHoliday.value = true;
}

const formatDate = (date) => {
    return date.replaceAll('-', '/');
}

</script>

<template>
    <div>
        <el-card class="box-card" body-style="padding:10px; background-color: #474CE6">
            <div class="f-flex align-items-center justify-content-start full-card mb-2">
                <div class="card-icon d-flex justify-content-start align-items-center header col-12 mb-2"
                    style="min-width: 300px;">
                    <img class="holiday-icon" src="@/assets/icons/island-white.svg" alt="islands-icon" width="47"
                        height="47">
                    <span class="card-title">Vacaciones</span>
                </div>
                <div class="row col-12 justify-content-start align-items-start" v-if="holidays.length <= 0">
                    <span class="text-holiday">
                        No hay compañeros de vacaciones
                    </span>
                </div>
                <div v-if="holidays.length > 0" class="holiday">
                    <div v-for="(holiday, index) in holidays.slice(0, 5)" :key="holiday.id" class="holiday-item">
                        <div class="holiday-info text-holiday">
                            {{ holiday.name }} {{ holiday.lastname }} ({{ formatDate(holiday.fromDate) }} - {{
                                formatDate(holiday.toDate) }})
                        </div>
                        <el-divider v-if="index < holidays.length - 1" class="divider" />
                    </div>
                    <div v-if="holidays.length > 5" class="more-text">
                        <div class="holiday-info text-holiday">
                        ... y otros compañeros, pulsa el + para ver al detalle
                        </div>
                    </div>
                </div>
                <div class="col-12 d-flex justify-content-end align-items-center" v-if="showHolidayButton">
                    <button class="btn btn_yellow align-self-end justify-content-end btn-plus-holidays"
                        @click="openDialogHolidays">+</button>
                </div>
            </div>
        </el-card>
        <!-- Dialog show full Holidays -->
        <el-dialog v-model="showDialogHoliday" :show-close="false" width="90%" style="max-width: 900px;"
            :style="{ borderRadius: `var(--el-border-radius-round)` }">
            <div class="my-header">
                <svg id="asterisk" xmlns="http://www.w3.org/2000/svg" width="724" height="1024" viewBox="0 0 724 1024">
                    <path
                        d="M0 499.8l59-181.7 332.5 108.6-59 180.8-332.5-107.7zM79.6 744.3l206.1-282.9 154.5 111.5-206.1 283.8-154.5-112.4zM266.9 167.3h191.1v350.3h-191.1v-350.3zM285.6 572.9l154.5-111.5 206.1 282.9-154.5 112.4-206.1-283.8zM332.5 426.8l332.5-108.6 59 181.7-331.6 107.7-59.9-180.8z" />
                </svg>
                <span class="text-header ml-5"> Vacaciones</span>
                <img class="close-icon pointer" src="@/assets/images/aspa_blue_small_entrada.png" alt=""
                    @click="showDialogHoliday = false">
            </div>
            <employees-with-holidays-new :holidays="holidaysResponse" />
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
.box-card {
    border-radius: 12px;
    color: white;
    margin-bottom: 15px;
}

.full-card {
    margin-left: 15px;
}

.header {
    min-width: 220px;
    width: 20%;
    height: 100%;

    span {
        letter-spacing: -0.05em;
        font-size: 1.3em;
        font-weight: bolder;
    }

    .card-title {
        margin: 0 10px;
        font-weight: 800;
        letter-spacing: -0.05em;
        font-size: 40px;
    }
}

.text-holiday {
    font-size: 16px;
    font-weight: 500;
}

.person-item {
    margin-bottom: 8px;
}

.divider {
    margin: 6px 0;
}

.btn-plus-holidays {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    font-size: 20px;
    font-weight: 700;
    line-height: 1;
    padding: 0;
}

.my-header {
    .text-header {
        margin-left: 2rem;
    }
}

@media screen and (max-width: 720px) {
    .my-header {
        .text-header {
            font-size: 2em !important;
            margin-left: 30px;
            margin-top: 0 !important;
        }

        #asterisk {
            width: 1.9em !important;
        }
    }
}

@media (max-height: 790px),
(max-width: 860px) {
    .header {
        .card-title {
            font-size: 30px;
        }
    }
}
</style>
